'use strict';

exports.__esModule = true;

var _extractFromEvent = require('./extractFromEvent');

var _extractFromEvent2 = _interopRequireDefault(_extractFromEvent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = (0, _extractFromEvent2['default'])('currentTarget.dataset');


//////////////////
// WEBPACK FOOTER
// ./~/react-decoration/lib/decorators/events/extractDataset.js
// module id = 566
// module chunks = 1